import { render, staticRenderFns } from "./AddMatchForBook.vue?vue&type=template&id=74cd2c36&scoped=true"
import script from "./AddMatchForBook.vue?vue&type=script&lang=js"
export * from "./AddMatchForBook.vue?vue&type=script&lang=js"
import style0 from "./AddMatchForBook.vue?vue&type=style&index=0&id=74cd2c36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cd2c36",
  null
  
)

export default component.exports